export default "__VITE_ASSET__D8Y9kYRt__"